export default "__VITE_ASSET__D0iMQgbT__"